export default __webpack_public_path__ + "static/media/edit.74daac67.svg";